import DOM from '@common/DOM/DOM'

import { ENavbarEvent } from '../../definitions'

import './SideMenuBg.css'

const NO_RESIZE_LIMIT = 991

/** Oldlasó menü megjelenése esetén megjelenő kifeszített háttér. */
export default function SideMenuBg (): HTMLElement {
  const bg: HTMLElement = <div className="sen-navbar__side-menu-bg" />

  /** Elrejtés. */
  function hide (): void {
    document.body.style.overflowY = 'visible'
    bg.removeAttribute('data-active')
  }

  /** Resizenál figyeli, hogyha a sideMenu már nem lesz látható, akkor clear. */
  function onResize (): void {
    if (window.innerWidth <= NO_RESIZE_LIMIT) {
      return
    }

    window.removeEventListener('resize', onResize)

    DOM.dispatch(document, ENavbarEvent.HideSideMenu)

    hide()
  }

  /** SideMenuButton click-nél eltüntetjük. */
  function onSideMenuButtonClick (): void {
    // Ha SideMenu-ben klikkelunk, akkor eltunteti a menut es a sidemenubg-t.
    if (bg.hasAttribute('data-active')) {
      hide()
    }
  }

  /** SideMenu megjelenítésekor, láthatóvá tesszük. */
  function onShowSideMenu (): void {
    document.body.style.overflowY = 'hidden'
    bg.setAttribute('data-active', '')

    window.addEventListener('resize', onResize)
  }

  bg.addEventListener('click', hide)

  document.addEventListener(ENavbarEvent.ShowSideMenu, onShowSideMenu)
  document.addEventListener(ENavbarEvent.HideSideMenu, hide)
  document.addEventListener(ENavbarEvent.SideButtonClicked, onSideMenuButtonClick)

  return bg
}
